import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPurchaseDocumentsApi } from "../../http/carPurchaseDocuments/api";
import { CarPurchaseDocument } from "../../http/carPurchaseDocuments/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarPurchaseDocumentDialogProps = {
  carPurchaseDocument: CarPurchaseDocument;
  onClose: () => void;
};

const DeleteCarPurchaseDocumentDialog: FC<DeleteCarPurchaseDocumentDialogProps> = ({
  carPurchaseDocument,
  onClose,
}) => {
  const i18n = useI18n();
  const carPurchaseDocumentsApi = useCarPurchaseDocumentsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carPurchaseDocumentsApi
              .deleteCarPurchaseDocument(carPurchaseDocument.id, carPurchaseDocument.carPurchase.id)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarPurchaseDocumentDialog;
